import { PortalModule } from '@/modules';
import { routes } from './routes';
import { tippspielStore } from './store';

export const tippspielModule: PortalModule = {
  routes,
  store: {
    name: 'tippspiel',
    module: tippspielStore,
  }
}